export default __webpack_public_path__ + "static/media/lock_alert.775bcaf0.mp3";